<div class="state-bg-check">
  <umss-card-header
    iconName="phosphorUserCheck"
    title="State Background Check"
  />

  @if (loading()) {
    <umss-skeleton variant="Object" [spacingY]="12" />
  } @else {
    <div class="state-bg-check__status">
      <umss-verified-indicator [verified]="isVerified()" />
      @if (isVerified() && verifiedDate()) {
        <span class="state-bg-check__date">
          {{ verifiedDate() | date: 'mediumDate' }}
        </span>
      }
    </div>

    <p class="state-bg-check__description">{{ descriptionText() }}</p>

    @if (notes(); as note) {
      <div class="state-bg-check__notes">
        <span class="state-bg-check__notes-label">{{ notesLabel }}</span>
        <p class="state-bg-check__notes-text">{{ note }}</p>
      </div>
    }

    <!-- App-specific extras, e.g. the contractor app's upload action. -->
    <ng-content select="[card-actions]" />
  }
</div>
